export default __webpack_public_path__ + "static/media/AddCustomer.53780007.png";